import * as commonFuns from '../modules/styles/styles-functions';

(function ($) {
    $(document).ready(function () {
        initImageGalleryCarousel();
    });

    $(window).resize(function () {
        initImageGalleryCarousel();
    });

    function initImageGalleryCarousel()
    {
        if (commonFuns.checkIsMobiles()) {
            $(".image-gallery-carousel").owlCarousel({
                items: 1,
                nav: true,
                navText: ["<i class='fa bg-chevron'></i>", "<i class='fa bg-chevron'></i>"],
                loop: true,
                dots: true,
                mouseDrag: true,
                touchDrag: true
            });
        }
    }
})(jQuery);